'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UploadS3 = function () {
  function UploadS3(el) {
    _classCallCheck(this, UploadS3);

    this.el = el;
    this.inputFile = this.el.querySelectorAll('.input-file')[0];
    this.inputHidden = this.el.querySelectorAll('.hidden-input')[0];
    this.progressbar = this.el.querySelectorAll('.progress-bar')[0];
    this.textField = this.el.querySelectorAll('.textfield')[0];

    this.onDelete();

    this.region = 'eu-west-1';

    //ISDIN
    this.publicKey = 'AKIAIGKYRTIJYREMQNJQ';
    this.privateKey = '9N0VOW2dDwAzyGZqki4VtCOJocacTFTH4laxbbK5';
    this.bucket = 'ugc.isdin.com/antipiojos';

    //events
    this.events();
  }

  _createClass(UploadS3, [{
    key: 'events',
    value: function events() {
      this.el.querySelectorAll('.fake-click')[0].addEventListener('click', this.onClickEvent.bind(this));
      this.el.querySelectorAll('.delete-click')[0].addEventListener('click', this.onDeleteEvent.bind(this));

      this.inputFile.addEventListener('change', this.changeEvent.bind(this));
    }
  }, {
    key: 'onClickEvent',
    value: function onClickEvent(ev) {
      ev.preventDefault();this.onClick();
    }
  }, {
    key: 'onClick',
    value: function onClick() {
      if (this.el.classList.contains('uploading')) {
        clearInterval(this.myVar);
        this.onDelete();
      } else {
        this.inputFile.click();
      }
    }
  }, {
    key: 'onDeleteEvent',
    value: function onDeleteEvent(ev) {
      ev.preventDefault();this.onDelete();
    }
  }, {
    key: 'onDelete',
    value: function onDelete() {
      this.globalTrigger(false);
      this.inputFile.value = "";
      this.inputHidden.value = "";
      this.percentatge = 0;
      this.change();
    }
  }, {
    key: 'changeEvent',
    value: function changeEvent(ev) {
      ev.preventDefault();this.change(ev.target.files[0]);
    }
  }, {
    key: 'change',
    value: function change() {
      var file = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

      if (file != undefined) {
        this.el.classList.add('uploading');
        this.upToS3(file);
      } else {
        this.el.classList.remove('uploading');
        this.el.classList.remove('is-uploaded');
      }
    }
  }, {
    key: 'globalTrigger',
    value: function globalTrigger(state) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      if (typeof window['updateS3'] != 'undefined') {
        window.updateS3(state, value);
      } else {
        console.log("window.updateS3() function doesn't exist!");
      }
    }
  }, {
    key: 'upToS3',
    value: function upToS3(file) {
      var _this = this;

      var profile = localStorage.getItem('profile') == null ? Date.now().toString() : JSON.parse(localStorage.getItem('profile')).user_id;
      var username = localStorage.getItem('username') == null ? 'nomail' : localStorage.getItem('username');

      var name = "antipiojos_" + profile + "_" + username.replace(/[.@]/g, "_") + "." + file.name.split(".").pop();
      // let name = "antipiojos_" + 231 + "_" + 'email@domain.com'.replace(/[.@]/g, "_") + "." + file.name.split(".").pop();

      var config = {
        customAuthMethod: this.signFunction.bind(this),
        aws_key: this.publicKey,
        bucket: this.bucket,
        awsRegion: this.region,
        logging: false,
        maxConcurrentParts: 1,
        progressIntervalMS: 200,
        maxFileSize: 20 * 1000000,
        computeContentMd5: true,
        cryptoMd5Method: function cryptoMd5Method(data) {
          var wordArray = CryptoJS.lib.WordArray.create(data);
          return CryptoJS.MD5(wordArray).toString(CryptoJS.enc.Base64);
        },
        cryptoHexEncodedHash256: function cryptoHexEncodedHash256(data) {
          return CryptoJS.SHA256(data).toString(CryptoJS.enc.Hex);
        }
      };

      Evaporate.create(config).then(function (ev) {
        ev.add({
          name: name,
          file: file,
          progress: function progress(_progress) {
            _this.percentatge = _progress * 100;
            _this.progressbar.style.width = _this.percentatge + '%';
          },
          error: function error(err) {
            console.log(err);
          }
        }).then(function (awsKey) {
          _this.el.classList.remove('uploading');
          _this.el.classList.add('is-uploaded');

          _this.textField.innerHTML = file.name;
          _this.inputHidden.value = awsKey;

          _this.globalTrigger(true, awsKey);
        }, function (reason) {
          alert('All files were not uploaded successfully:' + reason);
          _this.onDelete();
        });
      }, function (reason) {
        console.log('Evaporate failed to initialize: ', reason);
      });
    }
  }, {
    key: 'signFunction',
    value: function signFunction(signParams, signHeaders, to_sign, signatureDateTime, canonicalRequest) {
      var hmac = function hmac(key, value) {
        return CryptoJS.HmacSHA256(value, key);
        // return AWS.util.crypto.hmac(key, value,'buffer', 'sha256');
      };

      var hexhmac = function hexhmac(key, value) {
        return CryptoJS.HmacSHA256(value, key).toString(CryptoJS.enc.Hex);
        // return AWS.util.crypto.hmac(key, value, 'hex', 'sha256');
      };
      var timestamp = signatureDateTime.substr(0, 8);
      var date = hmac('AWS4' + this.privateKey, timestamp);
      var region = hmac(date, this.region);
      var service = hmac(region, 's3');
      var signing = hmac(service, 'aws4_request');
      return new Promise(function (resolve, reject) {
        resolve(hexhmac(signing, decodeURIComponent(to_sign)));
      });
    }
  }]);

  return UploadS3;
}();

var init = function init() {
  var elements = document.querySelectorAll('.upload-s3');
  Array.prototype.forEach.call(elements, function (el, i) {
    new UploadS3(el);
  });
};

domUtils.ready(init);
